import React from "react";
import AccreditationInput from "../../../components/AccreditationInput/AccreditationInput";
import AccreditationButton from "../../../components/AccreditationButton/AccreditationButton";
import "../../../styles/global.css";

const FirstStep = ({
  t,
  handleInputChange,
  credentials,
  errors,
  nextButtonRef,
  handleNext,
}) => {
  return (
    <div className="flex-direction-column gap-60">
      <div className="flex-direction-column gap-96">
        <div className="flex-direction-column gap-18">
          <p className="font-16 inria-sans-300 login-description">
            {t("ENTER_EMAIL")}
          </p>
          <form className="flex-direction-column gap-18">
            <AccreditationInput
              placeholder="user@domain.com"
              setInputValue={(value) => handleInputChange("email", value)}
              value={credentials.email}
              className={`login-input ${errors.email ? "error" : ""}`}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  nextButtonRef.current?.click();
                }
              }}
              autoComplete="email"
              name="email"
            />
            <div className="flex-direction-column gap-4">
              <AccreditationInput
                placeholder="input password"
                className={`login-input ${errors.password ? "error" : ""}`}
                setInputValue={(value) => handleInputChange("password", value)}
                value={credentials.password}
                type="password"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    nextButtonRef.current?.click();
                  }
                }}
                autoComplete="current-password"
                name="password"
              />
            </div>
          </form>
        </div>
      </div>
      <AccreditationButton
        type="save"
        title={t("NEXT")}
        className="login-btn"
        onClick={handleNext}
        ref={nextButtonRef}
      />
    </div>
  );
};

export default FirstStep;
